module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "bg",
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 18,
      "sm": 14,
      "md": 10,
      "lg": 6
    }
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("./assets/mrclogo.svg"),
      "alt": "MRC Asia"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.isIe && !_vm.user.isMFA) ? _c('el-form', {
    ref: "loginForm",
    attrs: {
      "label-position": "top",
      "model": _vm.user,
      "rules": _vm.rules,
      "disabled": _vm.isLocked
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "userid"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    model: {
      value: (_vm.user.userid),
      callback: function($$v) {
        _vm.user.userid = $$v
      },
      expression: "user.userid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.user.password = $$v
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/sign/forget"
    }
  }, [_vm._v("Forget Password?")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "danger",
      "plain": "",
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        _vm.submitForm('loginForm')
      }
    }
  }, [_vm._v("Log in")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isIe && _vm.user.isMFA) ? _c('el-form', {
    ref: "loginOTPForm",
    attrs: {
      "label-position": "top",
      "model": _vm.user,
      "disabled": _vm.isLocked
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "One_Time Password",
      "prop": "userKeyInOTP"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "inputmode": "numeric"
    },
    model: {
      value: (_vm.user.userKeyInOTP),
      callback: function($$v) {
        _vm.user.userKeyInOTP = $$v
      },
      expression: "user.userKeyInOTP"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "danger",
      "plain": "",
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        _vm.submitOTPForm('loginOTPForm')
      }
    }
  }, [_vm._v("Verify")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isResendLocked),
      expression: "isResendLocked"
    }],
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "danger",
      "plain": "",
      "disabled": _vm.isLocked
    },
    on: {
      "click": function($event) {
        _vm.resendOTPForm('loginOTPForm')
      }
    }
  }, [_vm._v("Resend OTP")])], 1), _vm._v(" "), _c('el-form-item', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isResendLocked),
      expression: "!isResendLocked"
    }],
    attrs: {
      "href": "/sign"
    }
  }, [_vm._v("Go back to Login")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isIe) ? _c('div', {
    staticClass: "warning"
  }, [_c('h2', [_vm._v("Internet Explorer is not supported. Please use a modern browser like Google Chrome, Firefox or Microsoft Edge.")])]) : _vm._e(), _vm._v(" "), (_vm.isLocked) ? _c('div', {
    staticClass: "warning"
  }, [_c('h3', [_vm._v("You’ve reached the maximum logon attempts. Your account has been locked. Please contact (65) 6235 2852 for more information.")])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59001419","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 183
// module chunks = 2